"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconAlertTriangleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 2C8.36594 2 8.70266 2.19989 8.8779 2.52115L14.8779 13.5211C15.0469 13.831 15.0401 14.207 14.8599 14.5105C14.6797 14.814 14.3529 15 14 15H2C1.64706 15 1.32026 14.814 1.1401 14.5105C0.95994 14.207 0.9531 13.831 1.1221 13.5211L7.1221 2.52115C7.29734 2.19989 7.63406 2 8 2ZM8 5C8.55228 5 9 5.44772 9 6V9C9 9.55228 8.55228 10 8 10C7.44772 10 7 9.55228 7 9V6C7 5.44772 7.44772 5 8 5ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 2C10.3589 2 10.6902 2.19229 10.8682 2.50386L18.8682 16.5039C19.0451 16.8134 19.0438 17.1936 18.8649 17.5019C18.686 17.8102 18.3565 18 18 18H2C1.64353 18 1.31401 17.8102 1.13509 17.5019C0.956168 17.1936 0.954898 16.8134 1.13176 16.5039L9.13176 2.50386C9.3098 2.19229 9.64114 2 10 2ZM10 5C10.5523 5 11 5.44772 11 6V12C11 12.5523 10.5523 13 10 13C9.44771 13 9 12.5523 9 12V6C9 5.44772 9.44771 5 10 5ZM11 15C11 15.5523 10.5523 16 10 16C9.44771 16 9 15.5523 9 15C9 14.4477 9.44771 14 10 14C10.5523 14 11 14.4477 11 15Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 2C12.3632 2 12.6978 2.19689 12.8742 2.51436L22.8742 20.5144C23.0462 20.8241 23.0416 21.2017 22.8619 21.5071C22.6822 21.8125 22.3543 22 22 22H2C1.64568 22 1.31781 21.8125 1.13813 21.5071C0.958444 21.2017 0.95377 20.8241 1.12584 20.5144L11.1258 2.51436C11.3022 2.19689 11.6368 2 12 2ZM12 7C12.5523 7 13 7.44772 13 8V15.0001C13 15.5523 12.5523 16.0001 12 16.0001C11.4477 16.0001 11 15.5523 11 15.0001V8C11 7.44772 11.4477 7 12 7ZM13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19Z'],
  params: {
    width: '32',
    height: '32',
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 2C16.5466 2 17.05 2.29735 17.3138 2.77609L30.8138 27.2761C31.0698 27.7408 31.0613 28.3061 30.7915 28.7629C30.5216 29.2197 30.0306 29.5 29.5 29.5H2.5C1.96945 29.5 1.47837 29.2197 1.20852 28.7629C0.938666 28.3061 0.930197 27.7408 1.18624 27.2761L14.6862 2.77609C14.95 2.29735 15.4534 2 16 2ZM16 8C16.8284 8 17.5 8.67157 17.5 9.5V20.5C17.5 21.3284 16.8284 22 16 22C15.1716 22 14.5 21.3284 14.5 20.5V9.5C14.5 8.67157 15.1716 8 16 8ZM17.5 25.5C17.5 26.3284 16.8284 27 16 27C15.1716 27 14.5 26.3284 14.5 25.5C14.5 24.6716 15.1716 24 16 24C16.8284 24 17.5 24.6716 17.5 25.5Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;